/**
 * Detail text of the webhook binding limit notice. A plan without the
 * Workflows feature cannot change automations or webhook settings, so the
 * notice names only the upgrade there.
 */
export function webhookBindingsDetailKey(workflowsAvailable?: boolean) {
  return workflowsAvailable === false
    ? ('com.streamlain.notification.automation-plan-limit.webhook-bindings-detail-upgrade' as const)
    : ('com.streamlain.notification.automation-plan-limit.webhook-bindings-detail' as const);
}
